<template>
    <div class="material-page">
        <!-- 搜索区域 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="物料名称">
                    <el-input v-model="searchForm.materialName" placeholder="输入物料名称" clearable
                        @input="handleInputSearch"> <!-- 实时输入过滤 -->
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                    <el-button type="success" @click="send" icon="el-icon-document">生成采购单</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 物料列表（新增多选列） -->
        <el-card class="material-list-card">
            <el-table :data="displayMaterialList" border stripe height="60vh" v-loading="loading"
                @selection-change="handleSelectionChange" ref="materialTable">
                <!-- 多选列 -->
                <el-table-column type="selection" reserve-selection width="55"></el-table-column>

                <el-table-column prop="materialName" label="物料名称" align="center"></el-table-column>
                <el-table-column prop="room" label="功能间" align="center"></el-table-column>

                <el-table-column prop="num" label="采购数量" align="center">
                    <template #default="scope">
                        {{ scope.row.num || 0 }}
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column prop="orderNumber" label="订单号" align="center"></el-table-column>
                <el-table-column prop="taskNumber" label="任务单号" align="center"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" :total="total"
                    layout="total, sizes, prev, pager, next, jumper" :disabled="loading"></el-pagination>
            </div>
        </el-card>

        <!-- 物料详情弹窗 -->
        <el-dialog title="物料详情" :visible.sync="detailVisible" width="600px">
            <el-descriptions :column="1" border v-if="currentMaterial">
                <el-descriptions-item label="物料名称">{{ currentMaterial.materialName }}</el-descriptions-item>
                <el-descriptions-item label="物料类型">{{ currentMaterial.materialType }}</el-descriptions-item>
                <el-descriptions-item label="物料编码">{{ currentMaterial.materialCode }}</el-descriptions-item>
                <el-descriptions-item label="采购数量">{{ currentMaterial.num || 0 }}</el-descriptions-item>
                <el-descriptions-item label="订单号">{{ currentMaterial.orderNumber || '无' }}</el-descriptions-item>
                <el-descriptions-item label="任务单号">{{ currentMaterial.taskNumber || '无' }}</el-descriptions-item>
            </el-descriptions>
            <div slot="footer">
                <el-button @click="detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getRequiredMaterials, calculateList } from "@/api/RequiredMaterials";

export default {
    name: "MaterialPage",
    data() {
        return {
            // 搜索表单
            searchForm: {
                materialName: "",
                materialType: "",
                materialCode: "",
            },
            // 物料列表数据
            allMaterialList: [], // 存储全量物料数据（仅初始化加载一次）
            filteredMaterialList: [], // 前端过滤后的物料数据
            displayMaterialList: [], // 当前页显示的物料数据
            total: 0, // 总条数
            currentPage: 1,
            pageSize: 10,
            loading: false,
            // 详情弹窗控制
            detailVisible: false,
            currentMaterial: null,
            // 选中的物料数组
            selectedMaterials: [],
        };
    },
    mounted() {
        this.loadAllMaterials(); // 初始化加载全量数据
    },
    methods: {
        send() {
            calculateList().then(response => {
                console.log(response);
                this.$message.success(response.message || '操作成功');
            }).catch(error => {
                console.error('calculateList接口调用失败:', error);
                this.$message.error('生成采购单失败，请重试');
            })
        },

        // 【核心修改】仅加载一次全量物料数据（无分页/查询参数）
        async loadAllMaterials() {
            this.loading = true;
            try {
                // 仅传递userId，不传递任何分页/查询参数
                const params = {
                    userId: localStorage.getItem("userId"),
                };

                const response = await getRequiredMaterials(params);
                console.log('全量物料数据:', response);

                // 存储全量数据
                this.allMaterialList = Array.isArray(response.data) ? response.data :
                    (response.data?.list || []);
                // 初始化过滤（显示全部）
                this.filteredMaterialList = [...this.allMaterialList];
                // 更新总数并执行分页
                this.total = this.filteredMaterialList.length;
                this.paginateData();

            } catch (error) {
                console.error("加载全量物料数据异常:", error);
                this.$message.error("网络异常，无法加载物料数据");
                this.allMaterialList = [];
                this.filteredMaterialList = [];
                this.displayMaterialList = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        // 【核心新增】前端物料名称过滤逻辑
        filterMaterials() {
            if (this.allMaterialList.length === 0) {
                this.filteredMaterialList = [];
                this.total = 0;
                this.paginateData();
                return;
            }

            // 物料名称模糊过滤（不区分大小写）
            let filtered = [...this.allMaterialList];
            const keyword = this.searchForm.materialName.trim().toLowerCase();
            if (keyword) {
                filtered = filtered.filter(item =>
                    item.materialName && item.materialName.toLowerCase().includes(keyword)
                );
            }

            // 更新过滤后的数据和总数
            this.filteredMaterialList = filtered;
            this.total = filtered.length;
            // 重新分页
            this.paginateData();
        },

        // 【新增】输入框实时过滤
        handleInputSearch() {
            this.currentPage = 1; // 输入时重置到第一页
            this.filterMaterials();
        },

        // 【修改】查询按钮点击（仅前端过滤）
        handleSearch() {
            this.currentPage = 1;
            this.filterMaterials();
        },

        // 前端分页计算
        paginateData() {
            if (this.filteredMaterialList.length === 0) {
                this.displayMaterialList = [];
                return;
            }
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayMaterialList = this.filteredMaterialList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            this.searchForm = {
                materialName: "",
                materialType: "",
                materialCode: "",
            };
            this.currentPage = 1;
            // 恢复显示全量数据
            this.filteredMaterialList = [...this.allMaterialList];
            this.total = this.filteredMaterialList.length;
            this.paginateData();
        },

        // 【修改】分页大小改变（纯前端）
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 切换页大小时重置页码
            this.paginateData(); // 仅前端重新分页
            // 滚动到表格顶部
            const tableEl = this.$refs.materialTable?.$el;
            if (tableEl) tableEl.scrollTop = 0;
        },

        // 【修改】当前页改变（纯前端）
        handleCurrentChange(page) {
            this.currentPage = page;
            this.paginateData(); // 仅前端重新分页
            // 滚动到表格顶部
            const tableEl = this.$refs.materialTable?.$el;
            if (tableEl) tableEl.scrollTop = 0;
        },

        // 查看物料详情
        viewDetail(material) {
            this.currentMaterial = { ...material };
            this.detailVisible = true;
        },

        // 多选框选中事件
        handleSelectionChange(val) {
            this.selectedMaterials = val;
            console.log('选中的物料:', this.selectedMaterials);
        },
    },
};
</script>

<style lang="scss" scoped>
.material-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-card {
    margin-bottom: 20px;

    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 10px 0;
    }
}

.material-list-card {
    .el-table {
        margin-bottom: 15px;
    }
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    padding: 10px 0;
}
</style>